/**
 * LA ZONA HORARIA QUE USA DE VERDAD UN BOT, para la pantalla (2-nov-2026; deuda de POST-LANZAMIENTO del 24-sep).
 *
 * `BotConfig` pintaba `config.timeZone || 'America/Santiago'`: con el campo sin guardar enseñaba Santiago, y el
 * servidor (`functions/bot/utils/resolveBookingTimeZone.js`) heredaba la de la ORGANIZACIÓN. El 2-nov el bot de prueba
 * mostró «Chile (Santiago)» y derivó con el plazo de New York. Esta función resuelve igual que el servidor —el bot, si
 * no la organización, si no Santiago— y dice de dónde sale, para que la pantalla lo diga. La paridad con el servidor,
 * en `functions/__tests__/zonaEfectiva.jest.test.js`.
 *
 * Mostrar la efectiva NO la guarda: guardar sin tocar el selector deja el bot heredando (persistir lo que se muestra
 * congelaría Santiago en bots que hoy heredan otra, que es lo que la nota del 24-sep descartó).
 *
 * CommonJS y pura para probarla desde `functions/__tests__`.
 */
const ZONA_POR_DEFECTO = 'America/Santiago';

/**
 * @param {{ zonaDelBot?: string|null, zonaDeLaOrg?: string|null }} p
 * @returns {{ zona: string, origen: 'bot'|'organizacion'|'defecto' }}
 */
function zonaEfectiva({ zonaDelBot = null, zonaDeLaOrg = null } = {}) {
  if (zonaDelBot) return { zona: zonaDelBot, origen: 'bot' };
  if (zonaDeLaOrg) return { zona: zonaDeLaOrg, origen: 'organizacion' };
  return { zona: ZONA_POR_DEFECTO, origen: 'defecto' };
}

module.exports = { zonaEfectiva, ZONA_POR_DEFECTO };
